import { ViewIcon } from '@chakra-ui/icons';
import { Flex, IconButton, Tooltip } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { DataTable } from 'components';
import { openImageForPrint } from 'core/utils';
import React from 'react';
import { InquiryKmData, ExpertisePointGroupTypeLabel } from 'types';

export interface AdminExpertisePointKmInquiriesHistoryTableProps {
  inquiriesData: InquiryKmData[];
}

export const AdminExpertisePointKmInquiriesHistoryTable: React.FC<AdminExpertisePointKmInquiriesHistoryTableProps> = ({
  inquiriesData,
}) => {
  const columnHelper = createColumnHelper<InquiryKmData>();

  const columns = [
    columnHelper.accessor('chassis', {
      header: 'Şase no',
    }),

    columnHelper.accessor('groupType', {
      header: 'Marka',
      cell: (info) => {
        const groupType = info.getValue();
        return groupType ? ExpertisePointGroupTypeLabel.get(groupType) || '-' : '-';
      },
    }),

    columnHelper.accessor('createdAt', {
      header: 'Tarih',
      cell: (info) => new Date(info.getValue()).toLocaleString('tr-TR'),
    }),

    columnHelper.accessor('imageUrl', {
      header: 'URL',
      cell: (info) => {
        return (
          <Flex gap={4}>
            <Tooltip label="Yazdır">
              <IconButton
                aria-label="Yazdır"
                icon={<ViewIcon />}
                onClick={() => openImageForPrint(info.getValue(), 'KM Sorgulama Yazdır')}
              />
            </Tooltip>
          </Flex>
        );
      },
    }),
  ];

  return (
    <DataTable
      data={inquiriesData}
      columns={columns}
      usePagination
      tableProps={{
        variant: 'striped',
        colorScheme: 'teal',
      }}
      title="Km Sorgulama Geçmişi"
    />
  );
};
